module.exports = __webpack_public_path__ + "img/home.cf7196c.png";